<template>
  <div>
    <div id="body">
      <div class="wrapper">
        <div class="usercenter">
          <UserLeftGuid :menuActive="'/user/download'"></UserLeftGuid>

          <div class="main">
            <div class="title">
              <h2>
                <svg t="1653550379011"
                     viewBox="0 0 1024 1024"
                     version="1.1"
                     xmlns="http://www.w3.org/2000/svg"
                     p-id="2054"
                     width="64"
                     height="64">
                  <path d="M867.99802469 440.80039506H725.59881482V13.60276543H298.40118518v427.19762963H156.00197531l355.99802469 355.99802469 355.99802469-355.99802469z m-498.39723456 71.19960494V84.80237037h284.79841974v427.19762963h41.68413235L512 696.08334222 327.91665778 512H369.60079013z"
                        p-id="2055"></path>
                  <path d="M927.1584237 725.59881482H867.99802469v142.39920987c0 39.22450963-31.97509531 71.19960494-71.19960494 71.19960494H227.20158025c-39.22450963 0-71.19960494-31.97509531-71.19960494-71.19960494V725.59881482h-71.19960494v142.39920987c0 78.31956543 64.07964445 142.39920987 142.39920988 142.39920988h569.5968395c78.31956543 0 142.39920987-64.07964445 142.39920988-142.39920988V737.63802075c0-6.60214518-5.43706075-12.03920592-12.03920593-12.03920593z"
                        p-id="2056"></path>
                </svg>
                我的下载
              </h2>
            </div>
            <div class="box">
              <div class="list-top">
                <div class="list-page-total">
                  共 {{ total }} 条 第{{ pageIndex }}/{{ pageCount }}页
                </div>
                <div class="list-search">
                  <el-input placeholder=""
                            size="small"
                            v-model="searchTitle">
                    <el-button slot="append"
                               size="small"
                               type="primary"
                               @click="handleSearch">
                      查询
                    </el-button>
                  </el-input>
                </div>
              </div>

              <div class="box-content"
                   v-loading="loading">
                <el-table :data="tableData"
                          style="width: 100%">
                  <el-table-column align="center"
                                   label="序号"
                                   type="index"
                                   width="80"
                                   :index="handleTableIndex">
                  </el-table-column>
                  <el-table-column align="center"
                                   label="标题"
                                   min-width=""
                                   prop="title">
                  </el-table-column>
                  <el-table-column align="center"
                                   label="时间"
                                   width="160">
                    <template #default="scope">
                      {{ dateFormat(scope.row.createTime) }}
                    </template>
                  </el-table-column>
                  <!-- <el-table-column align="center" label="操作" width="250">
                    <template #default="scope">
                      <el-button
                        type="text"
                        size="mini"
                        icon="el-icon-view"
                        @click="handleView(scope.row.dataId, scope.row.lngid)"
                        >查看
                      </el-button>
                    </template>
                  </el-table-column> -->
                </el-table>
                <div class="list-bottom">
                  <div class="list-page-total">
                    共 {{ total }} 条 第{{ pageIndex }}/{{ pageCount }}页
                  </div>
                  <div class="list-page">
                    <el-pagination :current-page="pageIndex"
                                   :page-size="pageSize"
                                   layout="prev,pager,next,jumper"
                                   :total="total"
                                   @current-change="handleCurrentPageChange">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserLeftGuid from "../../components/user/left_guid.vue";
import { axiosRequest, axiosOptions } from "../../util/request";
import moment from "moment";

export default {
  components: { UserLeftGuid },
  data () {
    return {
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      total: 0,
      loading: false,
      searchTitle: "",
    };
  },
  mounted () {
    this.getList();
  },
  methods: {
    handleTableIndex (index) {
      return ((this.pageIndex || 1) - 1) * (this.pageSize || 10) + index + 1;
    },
    dateFormat (cellValue, type) {
      if (!cellValue) return "";
      if (type === "date") {
        return moment(cellValue).format("YYYY-MM-DD");
      }
      return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
    },
    getList () {
      this.loading = true;

      axiosRequest(
        "/user/down-log-list",
        {
          title: this.searchTitle,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.total = res.data.data.total;
            this.pageCount = res.data.data.pages;
            this.tableData = res.data.data.records;
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleCurrentPageChange (currentPage) {
      this.pageIndex = currentPage;
      this.getList();
    },
    handleSearch () {
      this.pageIndex = 1;
      this.getList();
    },
    handleView (type, id) {
      //console.log(type + id);
      let routerName = "";
      if (type === 0) {
        routerName = "report_list";
      } else if (type === 1) {
        routerName = "qingbao_list";
      }
      if (id) {
        this.$router.push({ name: routerName, params: { id: id } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "~@/assets/css/usercenter.scss";
</style>
